import {Control as OLControl} from 'ol/control'
// import {VOID} from 'ol/functions.js';
// import MapEventType from 'ol/MapEventType.js';
// import {listen, unlistenByKey} from 'ol/events.js';
// import BaseObject from 'ol/Object.js';

/**
 * The enum for available directions.
 *
 * @enum {number}
 */
export const POSITION = {
    TOP_LEFT_VERTICAL: 'top-left-vertical',
    TOP_LEFT_HORIZONTAL: 'top-left-horizontal',
    CENTER_LEFT_VERTICAL: 'center-left-vertical',
    BOTTOM_LEFT_VERTICAL: 'bottom-left-vertical',
    BOTTOM_LEFT_HORIZONTAL: 'bottom-left-horizontal',

    TOP_RIGHT_VERTICAL: 'top-right-vertical',
    TOP_RIGHT_HORIZONTAL: 'top-right-horizontal',
    CENTER_RIGHT_VERTICAL: 'center-right-vertical',
    BOTTOM_RIGHT_VERTICAL: 'bottom-right-vertical',
    BOTTOM_RIGHT_HORIZONTAL: 'bottom-right-horizontal',

    CENTER_CENTER: 'center-center',
    BOTTOM_CENTER: 'bottom-center',

};



// OLControl.prototype.setMap = function setMap(map){
//     if (this.map_) {
//         removeNode(this.element);
//     }

//     for (let i = 0, ii = this.listenerKeys.length; i < ii; ++i) {
//         unlistenByKey(this.listenerKeys[i]);
//     }

//     this.listenerKeys.length = 0;
//     this.map_ = map;
//     if (this.map_) {
//         const target = this.target_
//             ? this.target_
//             : map.getOverlayContainerStopEvent();
//         target.appendChild(this.element);
//         if (this.render !== VOID) {
//             this.listenerKeys.push(
//                 listen(map, MapEventType.POSTRENDER, this.render, this)
//             );
//         }
//         map.render();
//     }

// }


// var Control = /*@__PURE__*/(function (OLControl) {
//     function Control(options) {
//         OLControl.apply(this, arguments);
//     }

//     if ( OLControl ) Control.__proto__ = OLControl;
//     Control.prototype = Object.create( OLControl && OLControl.prototype );
//     Control.prototype.constructor = OLControl;

//     return Control;
// }(OLControl));

class Control extends OLControl {
    constructor(args) {
        super(args);
    }
}

export default Control;
